// common/services/competition/listOrgCompetitions.ts
import req from '../../api/request'

export type OrgCompetitionListItem = {
  id: string
  name_full: string
  abbreviation: string
  starts_at: string | null
  ends_at: string | null
  is_registration_on: boolean
  /** Backend competition type — pre-fills the wizard's Competition Type select. */
  competition_type?: string | null
}

export type ListOrgCompetitionsFilters = {
  search?: string
  /** Filter to competitions matching the wizard's Step 2 sport selection. */
  sportId?: string | null
  /** Filter to competitions matching the wizard's Step 2 generic sport selection. */
  genericSportId?: string | null
}

export const listOrgCompetitions = async (
  orgId: string,
  filters: ListOrgCompetitionsFilters = {}
): Promise<OrgCompetitionListItem[]> => {
  // Latest end date first so the most recent / in-progress competitions
  // appear at the top of both source pickers (Step 1 Clone form, Step 3
  // Playoffs branch). Backend doesn't accept `created_at` as a sort key,
  // and `ends_at desc` is the closest proxy to "newest first".
  const query: Record<string, string | number> = {
    page: 1,
    per_page: 50,
    sort: 'ends_at',
    direction: 'desc',
  }
  if (filters.search) {
    query.query = filters.search
  }
  if (filters.sportId) {
    query.sport_id = filters.sportId
  }
  if (filters.genericSportId) {
    query.generic_sport_id = filters.genericSportId
  }
  const response = await req(`/organizations/${orgId}/schedules`, { query })
  return (response.data ?? []) as OrgCompetitionListItem[]
}
